<ion-row>
    <ion-col size="12" class="content-wrapper">
        <p class="emoji">🙁</p>
    </ion-col>
    <ion-col size="12" class="content-wrapper">
        <p class="miss-you">{{'decline-syndicate.miss'| translate}} <br>{{'decline-syndicate.you'| translate}}</p>
    </ion-col>
    <ion-col size="12" class="content-wrapper">
        <p class="sure-decline">{{'decline-syndicate.invite'| translate}} </p>
    </ion-col>
    <ion-col size="12" class="content-wrapper">
        <ion-button class="decline-btn" (click)="declineInvitation()">{{'decline-syndicate.Decline'| translate}}
        </ion-button>
    </ion-col>
    <ion-col size="12" class="content-wrapper">
        <p class="changed-mind" (click)="close()">{{'decline-syndicate.changed'| translate}}</p>
    </ion-col>
</ion-row>